import { SelectFilter } from '@retail/components';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { UserName } from '@retail/my-assortment/types';

interface Props {
  availableCreatedByUserNames: UserName[];
  createdByFilter?: string | null;
  setCreatedByFilter: (userName?: string) => void;
}

const getFullName = ({ givenName, familyName }: UserName) => `${givenName} ${familyName}`;

export const AddedByFilter = ({
  availableCreatedByUserNames,
  createdByFilter,
  setCreatedByFilter,
}: Props) => {
  const t = useMyAssortmentTFunction();

  return (
    <SelectFilter
      label={t('myAssortment.columns.addedBy')}
      placeholder={t('myAssortment.actions.selectUserName')}
      options={availableCreatedByUserNames}
      value={availableCreatedByUserNames.find(({ iamId }) => iamId === createdByFilter) ?? null}
      onChange={(user) => setCreatedByFilter(user?.iamId)}
      dividers
      getOptionKey={({ iamId }) => iamId}
      getOptionLabel={getFullName}
    />
  );
};
